import React from "react";
import { Flex } from "@chakra-ui/react";
import { AccordionItem, MedicationGroup } from "components";
import { StoredAnestheticProtocol } from "duck";
import { MedicationCalculationTypeEnum, RegionalBlockTypeEnum } from "requests";
import { getMeds } from "./duck";

const Protocol: React.FC<{ data: StoredAnestheticProtocol }> = ({ data }) => {
  const {
    preAnestheticMeds,
    additionalMeds,
    inductionMeds,
    epiduralCalc,
    regionalOralBlocks
  } = getMeds(data);

  return (
    <AccordionItem key={data._id} title={data.name} defaultExpanded={false}>
      <Flex direction="column" rowGap={12}>
        {!!preAnestheticMeds.length && (
          <MedicationGroup
            groupName="Pre-Anesthetic Medications"
            medications={preAnestheticMeds}
            medicationType={MedicationCalculationTypeEnum.PreAnesthetic}
            viewOnly
            expandedCards={false}
            hasTimeAdministered={false}
          />
        )}
        {!!inductionMeds.length && (
          <MedicationGroup
            groupName="Induction Medications"
            medications={inductionMeds}
            medicationType={MedicationCalculationTypeEnum.Induction}
            viewOnly
            expandedCards={false}
            hasTimeAdministered={false}
            hasAdditionalVolumeToBeDrawn={false}
          />
        )}
        {!!additionalMeds.length && (
          <MedicationGroup
            groupName="Additional Medications"
            medications={additionalMeds}
            medicationType={MedicationCalculationTypeEnum.Additional}
            viewOnly
            expandedCards={false}
            hasTimeAdministered={false}
          />
        )}
        {!!epiduralCalc.length && (
          <MedicationGroup
            groupName="Epidural/Regional Blocks"
            medications={epiduralCalc}
            medicationType={RegionalBlockTypeEnum.EpiduralCalculations}
            viewOnly
            expandedCards={false}
            hasTimeAdministered={false}
          />
        )}
        {!!regionalOralBlocks.length && (
          <MedicationGroup
            groupName="Regional Oral Blocks"
            medications={regionalOralBlocks}
            medicationType={RegionalBlockTypeEnum.RegionalOralBlocks}
            viewOnly
            expandedCards={false}
            hasTimeAdministered={false}
          />
        )}
      </Flex>
    </AccordionItem>
  );
};

export default Protocol;
